/**
 * React component for the case info box.
 *
 * @author  Micha Krapp
 * @version 2.0.0
 * @package megacase
 */

var React = require('react');
import Mssg from '../i18n/Mssg.jsx';

class CaseInfoBox extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentCase: props.data
         };
    }

    componentWillReceiveProps( nextProps ) {
        let newState = {
            currentCase: nextProps.data,
        };
        this.setState( newState );
    }

    render() {
        var classNames = 'lr-casefactory-stage-case-values';
        const caseData = this.state.currentCase;
        const weight = parseFloat( caseData.case.weight ).toFixed(2).replace( '.', ',');
        return <table className={classNames}>
            <tbody>
                <tr>
                    <td className='lr-casefactory-stage-case-value-description'>
                        <Mssg __key='current.interiors'/> <Mssg __key='width.height.depth'/>
                    </td>
                    <td className='lr-casefactory-stage-case-value'>
                        <span>{ caseData.case.dimensions.interior['width'] } x { caseData.case.dimensions.interior['height'] } x { caseData.case.dimensions.interior['depth'] }mm</span>
                    </td>
                </tr>

                <tr>
                    <td className='lr-casefactory-stage-case-value-description'>
                        <Mssg __key='current.exteriors'/> <Mssg __key='width.height.depth'/> (<Mssg __key='from.edge.to.edge'/>)
                    </td>
                    <td className='lr-casefactory-stage-case-value'>
                        <span>{ caseData.case.dimensions.exterior['width'] } x { caseData.case.dimensions.exterior['height'] } x { caseData.case.dimensions.exterior['depth'] }mm</span>
                    </td>
                </tr>

                <tr>
                    <td className='lr-casefactory-stage-case-value-description'>
                        <Mssg __key='own.weight'/>
                    </td>
                    <td className='lr-casefactory-stage-case-value'>
                        <span>{ weight } Kg</span>
                    </td>
                </tr>
            </tbody>
        </table>
    }
}

CaseInfoBox.contextTypes = {
    //emitter: PropTypes.object.isRequired
};

CaseInfoBox.defaultProps = {

};

module.exports = CaseInfoBox;


// WEBPACK FOOTER //
// ./js/caseconfigurator/components/UI/CaseInfoBox.jsx